export const reloadIfOnCartPage = ()=>{
    try {
        var _window_location;
        const path = ((_window_location = window.location) === null || _window_location === void 0 ? void 0 : _window_location.pathname) || '';
        if (/^\/cart(?:$|\/|(?:\.html$))/.test(path)) {
            window.location.reload();
            return true;
        }
    } catch (err) {
    /* ignore */ }
    return false;
};
